import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "footerComponent", "popoverProps"];
import { useCallback, useState } from 'react';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { POPOVER_WIDTH } from 'framework-asset-preview-lib/internal/shared/constants/assetPreview';
import AssetPreview from './AssetPreview';
import cachedHttp from '../../shared/api/cachedHttp';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ConnectedAssetPreviewPopover(_ref) {
  let {
      children,
      footerComponent,
      popoverProps
    } = _ref,
    assetPreviewProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [loadedCrmObject, setLoadedCrmObject] = useState(undefined);
  const handleOpenChange = useCallback(event => {
    // Wipe cache only when popover is not being rendered by another object type
    if (!event.target.value && !assetPreviewProps.originObjectType) {
      cachedHttp.wipeAll();
    }
    if (popoverProps.onOpenChange) {
      popoverProps.onOpenChange(event);
    }
  }, [assetPreviewProps.originObjectType, popoverProps]);
  return /*#__PURE__*/_jsx(Popover, Object.assign({}, popoverProps, {
    content: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(AssetPreview, Object.assign({}, assetPreviewProps, {
        onLoadCrmObject: setLoadedCrmObject,
        previewType: "popover"
      })), footerComponent && loadedCrmObject && /*#__PURE__*/_jsx(View, {
        as: "footer",
        paddingBlockStart: "0",
        paddingBlockEnd: "500",
        paddingInline: "500",
        children: footerComponent
      })]
    }),
    "data-test-id": "asset-preview-popover",
    onOpenChange: handleOpenChange,
    inlineSize: `${POPOVER_WIDTH}px`,
    maxInlineSize: `${POPOVER_WIDTH}px`,
    children: children
  }));
}